/**
 * Validated LG details for library editing
 * Contains specimen and extraction information for LG codes in EXTRACTION_COMPLETED status
 */
export interface ValidatedLgDetails {
  readonly lgCode: string;
  readonly specimenCode: string;
  readonly specimenId: string;
  readonly concentration: number;
  readonly ratio260_280: number;
  readonly ratio260_230: number;
  readonly extractionMethod: string;
  readonly wellLocation: string;
  readonly technology: string;
  readonly priority: string;
  readonly isReprocess: boolean;
}

/**
 * LG validation request
 */
export interface LgValidationRequest {
  readonly lgCode: string;
}

/**
 * LG validation response status
 */
export enum LgValidationStatus {
  VALID = 'VALID',
  NOT_FOUND = 'NOT_FOUND',
  INVALID_STATUS = 'INVALID_STATUS'
}

/**
 * LG validation response
 */
export interface LgValidationResponse {
  readonly status: LgValidationStatus;
  readonly details: ValidatedLgDetails | null;
  readonly message: string | null;
}
